import { inject, Injectable } from '@angular/core';
import { ActionItemOptions, PreviewDialogActionsService, ReduceVisibleActions } from '@mediahaven/shared';
import { ActionItem, ApiFragment, PerformedAction } from '@stylehaven/components';
import { NEVER, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GENERIC_RECORD_ACTION_TYPES } from '../../entities/actions/action-types.entity';
import { ActionsSandbox } from '../../sandboxes/actions.sandbox.service';

@Injectable({ providedIn: 'root' })
export class PortalPreviewDialogActionsService extends PreviewDialogActionsService {
    readonly #actionsSandbox = inject(ActionsSandbox);

    getActionItems(record: ApiFragment, actionItemOptions: ActionItemOptions): Observable<ActionItem[]> {
        return this.#actionsSandbox
            .getActionsJoined(GENERIC_RECORD_ACTION_TYPES, new ApiFragment(record.metadata), actionItemOptions)
            .pipe(map(actions => ReduceVisibleActions(actions)));
    }

    getPerformedActions(): Observable<PerformedAction<ApiFragment>> {
        // Not required for portal
        return NEVER;
    }
}
